import Phaser from "phaser";

export default class RecoveryScene extends Phaser.Scene {
  constructor() {
    super("RecoveryScene");
  }

  init(data) {
    this.lang = data.lang || data.language || "en";
    this.score = data.score || 0;
    this.blueCount = data.blueCount || 0;
    this.greenCount = data.greenCount || 0;
    this.starCount = data.starCount || 0;
    this.blueScore = data.blueScore || 0;
    this.greenScore = data.greenScore || 0;
    this.starScore = data.starScore || 0;
    this.missedQuestions = data.missedQuestions || [];
    this.recoveryIndex = 0;
    this.recoveryScore = 0;
  }

  create() {
    this.cameras.main.setBackgroundColor("#020617");

    window.dispatchEvent(
      new CustomEvent("biorev-mobile-ui", {
        detail: {
          mode: "recovery",
          hideRightPanel: false,
          visibleControls: [],
          powerStates: {
            one: false,
            two: false,
            three: false,
          },
        },
      }),
    );

    const rightPanel = document.getElementById("right-ui-panel");
    const gameplayContent = document.getElementById(
      "right-panel-gameplay-content",
    );
    const gameplayTimer = document.getElementById("gameplay-timer");
    const gameplayPowers = document.getElementById("gameplay-powers");
    const resultsCounters = document.getElementById("results-counters");
    const resultsTotal = document.getElementById("results-total");

    if (rightPanel) rightPanel.style.visibility = "visible";
    if (gameplayContent) gameplayContent.style.display = "";
    if (gameplayTimer) gameplayTimer.style.display = "none";
    if (gameplayPowers) gameplayPowers.style.display = "none";
    if (resultsCounters) resultsCounters.style.display = "";
    if (resultsTotal) resultsTotal.style.display = "none";

    const blueCountEl = document.getElementById("ui-blue-count");
    const greenCountEl = document.getElementById("ui-green-count");
    const starCountEl = document.getElementById("ui-star-count");
    const blueScoreEl = document.getElementById("ui-blue-score");
    const greenScoreEl = document.getElementById("ui-green-score");
    const starScoreEl = document.getElementById("ui-star-score");

    if (blueCountEl) blueCountEl.textContent = this.blueCount;
    if (greenCountEl) greenCountEl.textContent = this.greenCount;
    if (starCountEl) starCountEl.textContent = this.starCount;
    if (blueScoreEl) blueScoreEl.textContent = this.blueScore;
    if (greenScoreEl) greenScoreEl.textContent = this.greenScore;
    if (starScoreEl) starScoreEl.textContent = this.starScore;

    this.showIntro();
  }

  clearScene() {
    this.children.removeAll();
  }

  showIntro() {
    this.clearScene();

    this.add.rectangle(400, 300, 800, 600, 0x06130c, 1);

    this.add
      .rectangle(400, 300, 700, 420, 0x18231d, 0.98)
      .setStrokeStyle(3, 0x769b55);

    this.add
      .text(
        400,
        150,
        this.lang === "es"
          ? "Oportunidad de recuperación"
          : "Recovery Opportunity",
        {
          fontSize: "34px",
          color: "#ecfccb",
          fontFamily: '"Russo One", sans-serif',
          align: "center",
        },
      )
      .setOrigin(0.5);

    this.add
      .text(
        400,
        275,
        this.lang === "es"
          ? "Puedes corregir las preguntas que respondiste mal. Cada respuesta corregida vale el 50% de los puntos originales: 1000 puntos por pregunta."
          : "You can correct the questions you missed. Each corrected answer is worth 50% of the original points: 1000 points per question.",
        {
          fontSize: "24px",
          color: "#ffffff",
          fontFamily: '"Montserrat", sans-serif',
          align: "center",
          wordWrap: { width: 590 },
          lineSpacing: 8,
        },
      )
      .setOrigin(0.5);

    const button = this.add
      .rectangle(400, 440, 220, 54, 0x65a30d, 1)
      .setStrokeStyle(2, 0xd9f99d)
      .setInteractive({ useHandCursor: true });

    const label = this.add
      .text(400, 440, this.lang === "es" ? "Siguiente" : "Next", {
        fontSize: "20px",
        color: "#ffffff",
        fontStyle: "bold",
        fontFamily: '"Montserrat", sans-serif',
      })
      .setOrigin(0.5);

    button.on("pointerover", () => {
      button.setScale(1.04);
      label.setScale(1.04);
    });

    button.on("pointerout", () => {
      button.setScale(1);
      label.setScale(1);
    });

    button.on("pointerdown", () => this.showQuestion());
  }

  showQuestion() {
    this.clearScene();

    if (this.recoveryIndex >= this.missedQuestions.length) {
      this.finishRecovery();
      return;
    }

    const item = this.missedQuestions[this.recoveryIndex];
    const wrongAnswerText = item.selectedAnswer;
    const answers = item.answers || [];
    let selectedAnswer = null;
    let submitted = false;

    const effectsVolume = Number(
      localStorage.getItem("agritech-effects-volume") ?? "0.6",
    );

    const playTap = () => {
      this.sound.play("tap", { volume: effectsVolume * 0.45 });
    };

    const playSelected = () => {
      this.sound.play("selected", { volume: effectsVolume * 0.5 });
    };

    const playCorrect = () => {
      this.sound.play("correct", { volume: effectsVolume * 0.6 });
    };

    const playIncorrect = () => {
      this.sound.play("incorrect", { volume: effectsVolume * 0.6 });
    };

    this.add.rectangle(400, 300, 800, 600, 0x06130c, 1);

    this.add
      .rectangle(400, 300, 700, 500, 0x18231d, 0.98)
      .setStrokeStyle(3, 0x769b55);

    this.add
      .text(
        400,
        72,
        this.lang === "es"
          ? `Pregunta ${this.recoveryIndex + 1} de ${this.missedQuestions.length}`
          : `Question ${this.recoveryIndex + 1} of ${this.missedQuestions.length}`,
        {
          fontSize: "22px",
          color: "#a3e635",
          fontStyle: "bold",
          fontFamily: '"Montserrat", sans-serif',
          align: "center",
        },
      )
      .setOrigin(0.5);

    this.add
      .text(365, 135, item.question, {
        fontSize: "21px",
        color: "#ecfccb",
        fontStyle: "bold",
        fontFamily: '"Montserrat", sans-serif',
        align: "center",
        wordWrap: { width: 520 },
        lineSpacing: 5,
      })
      .setOrigin(0.5);

    const timerX = 700;
    const timerY = 100;
    const timerRadius = 28;

    const timerGraphics = this.add.graphics().setDepth(3003);

    const countdownText = this.add
      .text(timerX, timerY, "", {
        fontSize: "27px",
        color: "#a3e635",
        fontFamily: '"Russo One", sans-serif',
      })
      .setOrigin(0.5)
      .setDepth(3004)
      .setVisible(false);

    const feedback = this.add
      .text(400, 500, "", {
        fontSize: "18px",
        color: "#f7faf4",
        fontStyle: "bold",
        fontFamily: '"Montserrat", sans-serif',
        align: "center",
      })
      .setOrigin(0.5);

    const finalButton = this.add.rectangle(400, 545, 240, 42, 0x405747, 1);

    const finalText = this.add
      .text(
        400,
        545,
        this.lang === "es" ? "Respuesta final" : "Final Answer?",
        {
          fontSize: "17px",
          color: "#aab7ad",
          fontStyle: "bold",
          fontFamily: '"Montserrat", sans-serif',
        },
      )
      .setOrigin(0.5);

    const rows = [];
    const QUESTION_TIME_MS = 35000;
    let questionTimerInterval = null;
    let countdownFlashTimeout = null;
    let timerExpired = false;
    let lastDisplayedSecond = null;

    const stopQuestionTimer = (removeVisuals = true) => {
      if (questionTimerInterval !== null) {
        window.clearInterval(questionTimerInterval);
        questionTimerInterval = null;
      }

      if (countdownFlashTimeout !== null) {
        window.clearTimeout(countdownFlashTimeout);
        countdownFlashTimeout = null;
      }

      if (removeVisuals) {
        if (timerGraphics?.active) timerGraphics.destroy();
        if (countdownText?.active) countdownText.destroy();
      }
    };

    const drawQuestionTimer = (remainingRatio, remainingSeconds) => {
      timerGraphics.clear();

      timerGraphics.lineStyle(6, 0x405747, 0.75);
      timerGraphics.strokeCircle(timerX, timerY, timerRadius);

      if (remainingRatio > 0) {
        timerGraphics.lineStyle(
          6,
          remainingSeconds <= 5 ? 0xef4444 : 0xa3e635,
          1,
        );

        timerGraphics.beginPath();
        timerGraphics.arc(
          timerX,
          timerY,
          timerRadius,
          -Math.PI / 2,
          -Math.PI / 2 - Math.PI * 2 * remainingRatio,
          true,
        );
        timerGraphics.strokePath();
      }

      if (remainingSeconds <= 5) {
        countdownText
          .setText(String(remainingSeconds))
          .setColor(remainingSeconds <= 2 ? "#ef4444" : "#a3e635")
          .setVisible(true);

        if (remainingSeconds !== lastDisplayedSecond) {
          lastDisplayedSecond = remainingSeconds;

          countdownText.setScale(1.45).setAlpha(1);

          if (countdownFlashTimeout !== null) {
            window.clearTimeout(countdownFlashTimeout);
          }

          countdownFlashTimeout = window.setTimeout(() => {
            if (countdownText?.active) {
              countdownText.setScale(1).setAlpha(0.9);
            }
          }, 180);
        }
      } else {
        countdownText.setVisible(false);
      }
    };

    const activateFinalButton = () => {
      finalButton.setFillStyle(0x65a30d, 1);
      finalButton.setInteractive({ useHandCursor: true });
      finalText.setColor("#ffffff");
    };

    const selectAnswer = (answer, row) => {
      if (submitted) return;

      playSelected();
      selectedAnswer = answer;

      rows.forEach((itemRow) => {
        if (itemRow.disabled) return;

        itemRow.button.setFillStyle(0x0b1510, 1);
        itemRow.button.setStrokeStyle(1, 0x405747);
        itemRow.keyBox.setFillStyle(0x0b1510, 1);
        itemRow.keyBox.setStrokeStyle(1, 0x405747);
        itemRow.numberText.setColor("#ffffff");
        itemRow.answerText.setColor("#ffffff");
      });

      row.button.setFillStyle(0x18291f, 1);
      row.button.setStrokeStyle(2, 0xa3e635);
      row.keyBox.setFillStyle(0x65a30d, 1);
      row.keyBox.setStrokeStyle(1, 0xa3e635);
      row.numberText.setColor("#ffffff");
      row.answerText.setColor("#d9f99d");

      activateFinalButton();
    };

    const handleQuestionTimeout = () => {
      if (submitted || timerExpired) return;

      timerExpired = true;
      submitted = true;

      rows.forEach((row) => {
        row.button.disableInteractive();
        row.answerText.disableInteractive();
      });

      finalButton.disableInteractive();

      feedback.setText(
        this.lang === "es" ? "¡Se acabó el tiempo!" : "Time's up!",
      );
      feedback.setColor("#fca5a5");

      window.dispatchEvent(
        new CustomEvent("biorev-record-recovery-answer", {
          detail: {
            language: this.lang,
            recoveryQuestion: true,
            question: item.question,
            selectedAnswer: "",
            originalWrongAnswer: item.selectedAnswer,
            correctAnswer:
              item.answers.find((answerData) => answerData.correct)?.text ?? "",
            wasCorrect: false,
            recoveredPoints: 0,
            timedOut: true,
            tier: item.tier,
          },
        }),
      );

      finalButton.setFillStyle(0x65a30d, 1);
      finalButton.setInteractive({ useHandCursor: true });
      finalText.setText(this.lang === "es" ? "Continuar" : "Continue");
      finalText.setColor("#ffffff");

      finalButton.once("pointerdown", () => {
        stopQuestionTimer();
        this.recoveryIndex += 1;
        this.showQuestion();
      });
    };
    const submitSelected = () => {
      if (!selectedAnswer || submitted || timerExpired) return;

      playSelected();

      submitted = true;
      stopQuestionTimer();

      rows.forEach((row) => {
        row.button.disableInteractive();
        row.answerText.disableInteractive();
      });

      finalButton.disableInteractive();

      const corrected = !!selectedAnswer.correct;

      if (corrected) {
        playCorrect();

        this.recoveryScore += 1000;
        this.starCount += 0.5;

        const scoreEl = document.getElementById("ui-score");
        const starCountEl = document.getElementById("ui-star-count");
        const starScoreEl = document.getElementById("ui-star-score");

        if (scoreEl) scoreEl.textContent = this.score + this.recoveryScore;
        if (starCountEl) starCountEl.textContent = this.starCount;

        if (starScoreEl) {
          const currentStarScore = Number(starScoreEl.textContent || 0);
          starScoreEl.textContent = currentStarScore + 1000;
        }

        feedback.setText(
          this.lang === "es"
            ? "¡Correcto! +1000 puntos."
            : "Correct! +1000 points.",
        );
        feedback.setColor("#86efac");
      } else {
        playIncorrect();

        feedback.setText(this.lang === "es" ? "Incorrecto." : "Incorrect.");
        feedback.setColor("#fca5a5");
      }

      window.dispatchEvent(
        new CustomEvent("biorev-record-recovery-answer", {
          detail: {
            language: this.lang,
            recoveryQuestion: true,
            question: item.question,
            selectedAnswer: selectedAnswer.text,
            originalWrongAnswer: item.selectedAnswer,
            correctAnswer:
              item.answers.find((answerData) => answerData.correct)?.text ?? "",
            wasCorrect: corrected,
            recoveredPoints: corrected ? 1000 : 0,
            tier: item.tier,
          },
        }),
      );

      finalButton.setFillStyle(0xfacc15, 1);
      finalButton.setInteractive({ useHandCursor: true });
      finalText.setText(this.lang === "es" ? "Continuar" : "Continue");
      finalText.setColor("#111827");

      finalButton.once("pointerdown", () => {
        cleanupKeyboard();
        this.recoveryIndex += 1;
        this.showQuestion();
      });
    };

    answers.forEach((answer, index) => {
      const y = 215 + index * 72;
      const wasWrongChoice = answer.text === wrongAnswerText;

      const button = this.add
        .rectangle(400, y, 620, 58, wasWrongChoice ? 0x2f2f2f : 0x0b1510, 1)
        .setStrokeStyle(1, wasWrongChoice ? 0x525252 : 0x405747);

      const keyBox = this.add
        .rectangle(115, y, 48, 58, wasWrongChoice ? 0x2f2f2f : 0x0b1510, 1)
        .setStrokeStyle(1, wasWrongChoice ? 0x525252 : 0x405747);

      const numberText = this.add
        .text(115, y, `${index + 1}`, {
          fontSize: "18px",
          color: wasWrongChoice ? "#888888" : "#ffffff",
          fontStyle: "bold",
          fontFamily: '"Montserrat", sans-serif',
        })
        .setOrigin(0.5);

      const answerText = this.add
        .text(160, y, answer.text, {
          fontSize: "14px",
          color: wasWrongChoice ? "#888888" : "#ffffff",
          fontFamily: '"Montserrat", sans-serif',
          align: "left",
          wordWrap: { width: 520 },
          lineSpacing: 3,
        })
        .setOrigin(0, 0.5);

      const row = {
        button,
        keyBox,
        numberText,
        answerText,
        disabled: wasWrongChoice,
      };

      rows.push(row);

      if (wasWrongChoice) return;

      button.setInteractive({ useHandCursor: true });
      answerText.setInteractive({ useHandCursor: true });

      button.on("pointerover", () => {
        if (submitted || selectedAnswer === answer) return;

        playTap();

        button.setFillStyle(0x18291f, 1);
        keyBox.setFillStyle(0x18291f, 1);
      });

      button.on("pointerout", () => {
        if (submitted || selectedAnswer === answer) return;
        button.setFillStyle(0x0b1510, 1);
        keyBox.setFillStyle(0x0b1510, 1);
      });

      button.on("pointerdown", () => selectAnswer(answer, row));
      answerText.on("pointerdown", () => selectAnswer(answer, row));
    });

    const selectAnswerByIndex = (index) => {
      const answer = answers[index];
      const row = rows[index];

      if (!answer || !row || row.disabled || submitted) return;

      selectAnswer(answer, row);
    };

    const selectOne = () => selectAnswerByIndex(0);
    const selectTwo = () => selectAnswerByIndex(1);
    const selectThree = () => selectAnswerByIndex(2);
    const selectFour = () => selectAnswerByIndex(3);

    const cleanupKeyboard = () => {
      this.input.keyboard.off("keydown-ONE", selectOne);
      this.input.keyboard.off("keydown-TWO", selectTwo);
      this.input.keyboard.off("keydown-THREE", selectThree);
      this.input.keyboard.off("keydown-FOUR", selectFour);
      this.input.keyboard.off("keydown-ENTER", pressReturn);
    };

    const pressReturn = () => {
      if (!submitted) {
        submitSelected();
        return;
      }

      cleanupKeyboard();
      this.recoveryIndex += 1;
      this.showQuestion();
    };

    this.input.keyboard.on("keydown-ONE", selectOne);
    this.input.keyboard.on("keydown-TWO", selectTwo);
    this.input.keyboard.on("keydown-THREE", selectThree);
    this.input.keyboard.on("keydown-FOUR", selectFour);
    this.input.keyboard.on("keydown-ENTER", pressReturn);

    finalButton.on("pointerdown", submitSelected);

    const questionStartedAt = performance.now();

    drawQuestionTimer(1, QUESTION_TIME_MS / 1000);

    questionTimerInterval = window.setInterval(() => {
      const elapsed = performance.now() - questionStartedAt;
      const remainingMs = Math.max(0, QUESTION_TIME_MS - elapsed);
      const remainingRatio = remainingMs / QUESTION_TIME_MS;
      const remainingSeconds =
        remainingMs <= 0 ? 0 : Math.ceil(remainingMs / 1000);

      drawQuestionTimer(remainingRatio, remainingSeconds);

      if (remainingMs <= 0) {
        stopQuestionTimer(false);
        handleQuestionTimeout();
      }
    }, 50);
  }

  submitRecoveryAnswer(item, answer) {
    const corrected = !!answer.correct;

    if (corrected) {
      this.recoveryScore += 1000;
    }

    window.dispatchEvent(
      new CustomEvent("biorev-record-recovery-answer", {
        detail: {
          language: this.lang,
          recoveryQuestion: true,
          question: item.question,
          selectedAnswer: answer.text,
          originalWrongAnswer: item.selectedAnswer,
          correctAnswer:
            item.answers.find((answerData) => answerData.correct)?.text ?? "",
          wasCorrect: corrected,
          recoveredPoints: corrected ? 1000 : 0,
          tier: item.tier,
        },
      }),
    );

    this.recoveryIndex += 1;
    this.showQuestion();
  }

  finishRecovery() {
    this.scene.start("ResultScene", {
      score: this.score + this.recoveryScore,
      originalScore: this.score,
      recoveryScore: this.recoveryScore,
      blueCount: this.blueCount,
      greenCount: this.greenCount,
      starCount: this.starCount,
      blueScore: this.blueScore,
      greenScore: this.greenScore,
      starScore: this.starScore + this.recoveryScore,
      lang: this.lang,
    });
  }
}
